import { defineMessages } from "react-intl";

const messages = defineMessages({
    play: {
        id: "audio.play",
    },
    submit: {
        id: "task.submit",
    },
});

export default messages;
